<div class="verification-container">
  <div class="verification-card">
    <div class="verification-content">
      <!-- Icon Container -->
      <div class="icon-container">
        <div class="icon-circle no-bg {{verificationStatus}}">
          <!-- Loading State -->
          <svg *ngIf="verificationStatus === 'loading'" class="custom-svg-icon" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="28" cy="28" r="24" stroke="#2563eb" stroke-width="6" opacity="0.2"/>
            <circle cx="28" cy="28" r="24" stroke="#2563eb" stroke-width="6" stroke-linecap="round" stroke-dasharray="150" stroke-dashoffset="100" >
              <animateTransform attributeName="transform" type="rotate" from="0 28 28" to="360 28 28" dur="1s" repeatCount="indefinite" />
            </circle>
          </svg>
          <!-- Success State -->
          <svg *ngIf="verificationStatus === 'success'" class="custom-svg-icon" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="shield-success" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
                <stop stop-color="#22c55e"/>
                <stop offset="1" stop-color="#16a34a"/>
              </linearGradient>
            </defs>
            <path d="M28 6L48 14V26C48 39 36.5 47 28 50C19.5 47 8 39 8 26V14L28 6Z" fill="url(#shield-success)"/>
            <path d="M20 29L26 35L36 23" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <!-- Error State -->
          <svg *ngIf="verificationStatus === 'error'" class="custom-svg-icon" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="shield-error" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
                <stop stop-color="#dc2626"/>
                <stop offset="1" stop-color="#b91c1c"/>
              </linearGradient>
            </defs>
            <path d="M28 6L48 14V26C48 39 36.5 47 28 50C19.5 47 8 39 8 26V14L28 6Z" fill="url(#shield-error)"/>
            <path d="M22 22L34 34M34 22L22 34" stroke="#fff" stroke-width="3.5" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
      
      <!-- Header -->
      <div class="verification-header">
        <h1>Vérification de l'e-mail</h1>
        <div class="header-line"></div>
      </div>

      <!-- Content -->
      <!-- Loading State -->
      <div *ngIf="verificationStatus === 'loading'" class="status-loading">
        <h2>Vérification en cours...</h2>
        <p>Nous vérifions votre adresse e-mail. Cette opération ne prend que quelques instants.</p>
      </div>

      <!-- Success State -->
      <div *ngIf="verificationStatus === 'success'" class="status-success">
        <h2>E-mail vérifié avec succès !</h2>
        <p class="black-text">Félicitations ! Votre adresse e-mail a été confirmée avec succès.<br><strong>Votre compte sera bientôt activé par l'administrateur pour accéder à toutes les fonctionnalités.</strong></p>
      </div>

      <!-- Error State -->
      <div *ngIf="verificationStatus === 'error'" class="status-error">
        <h2>Lien de vérification invalide</h2>
        <p>Le lien de vérification a expiré ou est incorrect.<br>Veuillez demander un nouveau lien ou créer un nouveau compte.</p>
      </div>

      <!-- Actions - Stacked Buttons -->
      <div class="actions">
        <!-- Success State Actions -->
        <button class="btn btn-primary ripple" *ngIf="verificationStatus === 'success'" (click)="goToLogin()">
          <span class="material-icons">login</span>
          <span class="btn-text">Se connecter</span>
        </button>

        <!-- Error State Actions -->
        <button class="btn btn-danger ripple" *ngIf="verificationStatus === 'error'" (click)="goToSignup()">
          <span class="material-icons">refresh</span>
          <span class="btn-text">Nouveau compte</span>
        </button>
        <button class="btn btn-primary ripple" *ngIf="verificationStatus === 'error'" (click)="goToLogin()">
          <span class="material-icons">login</span>
          <span class="btn-text">Se connecter</span>
        </button>
      </div>
    </div>
  </div>
</div> 